import {SubscriptionInfoModel} from './SubscriptionInfo.model';
import {DescriptionLineModel} from './DescriptionLine.model';
import {ImageModel} from './Image.model';
import {PhysicalPropertiesModel} from './PhysicalProperties.model';
import {UrlModel} from './Url.model';

export class AttributesModel {
  public itemType: string;
  public image: ImageModel;
  public physicalProperties: PhysicalPropertiesModel;
  public url: UrlModel;
  public descriptionLines: DescriptionLineModel[];
  public subscriptionInfo?: SubscriptionInfoModel;

  constructor(params: AttributesModel) {
    this.itemType = params.itemType;
    this.image = params.image;
    this.physicalProperties = params.physicalProperties;
    this.url = params.url;
    this.descriptionLines = params.descriptionLines;
    this.subscriptionInfo = params.subscriptionInfo;
  }

  public static fromCartV1({
    shippable,
    itemType,
    url,
    image,
    descriptionLines,
    subscriptionInfo,
  }: {
    shippable?: boolean;
    itemType?: string;
    url?: UrlModel;
    image?: ImageModel;
    descriptionLines?: DescriptionLineModel[];
    subscriptionInfo?: SubscriptionInfoModel;
  }) {
    return new AttributesModel({
      itemType,
      image,
      url,
      physicalProperties: PhysicalPropertiesModel.fromCartV1({shippable}),
      descriptionLines,
      subscriptionInfo,
    });
  }
}
